import { CREDIT_LIMITS, CREDIT_MEANING, CREDIT_READ_AGAIN } from "../../../model/credit-words.ts";
import type { PRICING_WORDS_EN } from "./pricing-words-en.ts";

// The pricing family's Spanish words (ADR-034 points 1 and 2): only this family edits them. Every
// price and credit count comes from the contracts through a `{name}` place, never from here.
export const PRICING_WORDS_ES: typeof PRICING_WORDS_EN = {
  footerTitle: "Precios",
  footerLink: "Planes y créditos",
  creditMeaning: CREDIT_MEANING.es,
  keyphrase: "precios",
  title: "Precios: planes y créditos · {product}",
  description:
    "Precios de {product}: empieza gratis con {welcome} créditos, planes de pago desde {price} al mes. {meaning}",
  breadcrumbHome: "Inicio",
  breadcrumbPage: "Precios",
  eyebrow: "Planes y créditos",
  heading: "Precios: empieza gratis con {welcome} créditos",
  lede: "{meaning} {limits}",
  plansTitle: "Elige un plan",
  plansDescription: "Los precios están en euros. Se añade el IVA cuando corresponde.",
  periodLabel: "Período de facturación",
  mostPopular: "Más popular",
  periodMonth: "Mensual",
  periodYear: "Anual",
  periodDiscount: "-{discount}%",
  perMonth: "/mes",
  perYear: "/año",
  billedMonthly: "Se factura cada mes",
  billedYearly: "{discount}% de descuento, se factura una vez al año",
  plans: {
    free: {
      name: "Gratis",
      tagline: "Pruébalo con una cuenta real",
      action: "Empieza gratis",
      lines: ["{welcome} créditos de bienvenida, una vez", "{seats} asientos", "Sin tarjeta de crédito"],
    },
    starter: {
      tagline: "Para pequeñas empresas y autónomos",
      action: "Elegir Starter",
    },
    growth: {
      tagline: "Para equipos que llegan a más gente",
      action: "Elegir Growth",
    },
    enterprise: {
      tagline: "Para equipos en crecimiento",
      action: "Elegir Enterprise",
    },
  },
  creditsLine: "{credits} créditos al mes",
  seatsLine: "{seats} asientos",
  helperTitle: "¿Cuántos créditos necesitas?",
  helperLabel: "Créditos al mes",
  helperEmpty: "Escribe un número de créditos para ver la forma más barata de cubrirlos.",
  helperWelcome:
    "Los {welcome} créditos de bienvenida del plan {plan} cubren {credits}, una vez y sin tarjeta.",
  helperMonth: "{plan} cubre {credits} créditos, por {price} al mes.",
  helperYear: "{plan} cubre {credits} créditos, por {price} al año.",
  helperPackAlone: "Un paquete de {pack} cubre {credits} créditos, pagado una vez y sin plan.",
  helperPacksAlone: "{count} paquetes por {pack} cubren {credits} créditos, pagados una vez y sin plan.",
  helperPlanPackMonth: "{plan} más un paquete de {pack} cubre {credits} créditos, por {total} el primer mes.",
  helperPlanPacksMonth:
    "{plan} más {count} paquetes por {pack} cubre {credits} créditos, por {total} el primer mes.",
  helperPlanPackYear:
    "{plan} por {price} al año más un paquete de {pack} cubre {credits} créditos, {total} por adelantado.",
  helperPlanPacksYear:
    "{plan} por {price} al año más {count} paquetes por {pack} cubre {credits} créditos, {total} por adelantado.",
  helperPacksOnce:
    "Los paquetes se pagan una vez y se acumulan, así que necesitar {credits} cada mes implica comprar más.",
  helperAlsoMonth: "{plan} incluye {included} créditos al mes por {price} al mes, con más cuentas de envío.",
  helperAlsoYear: "{plan} incluye {included} créditos al mes por {price} al año, con más cuentas de envío.",
  helperPack:
    "Los créditos adicionales empiezan en {price} por {credits}, se pagan una vez y se acumulan hasta usarlos.",
  faqLabel: "Preguntas",
  faqTitle: "Preguntas, respondidas",
  relatedTitle: "Míralo en uso",
  questions: [
    {
      question: "¿Qué compra un crédito?",
      answer: `${CREDIT_MEANING.es} ${CREDIT_LIMITS.es} ${CREDIT_READ_AGAIN.es}`,
    },
    {
      question: "¿Qué cuentas puedo leer?",
      answer: "Los seguidores de una cuenta de Instagram y las cuentas que sigue.",
    },
    {
      question: "¿Necesito una tarjeta para el plan gratis?",
      answer: "No. Tus {welcome} créditos de bienvenida llegan una vez, cuando verificas tu correo.",
    },
    {
      question: "¿Puedo pagar al año?",
      answer: "Sí, con un {discount}% de descuento sobre el precio mensual, facturado una vez al año.",
    },
    {
      question: "¿Los créditos sin usar se acumulan?",
      answer:
        "Los créditos de un plan no se acumulan al mes siguiente. Los paquetes de créditos que compres por separado se acumulan hasta que se usen.",
    },
  ],
};
